import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { Observable } from 'rxjs';
import { UserService } from '../service/user.service';
import { environment } from 'src/environments/environment';
import { AuthService } from '../service/auth.service';

@Injectable({
    providedIn: 'root',
})
export class AuthGuard {
    loginURL = '/auth/login';

    constructor(
        private router: Router,
        private userService: UserService,
        private Cookies: CookieService,
        private authService: AuthService
    ) { }

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        if (this.router.url === '/' && state.url === '/CVDST/promote') {
            return this.router.navigate(['/GYXJ6/CVDST/promote']);
        } else {
            return this.checkAuthentication(route, state);
        }
    }

    canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (this.router.url === '/' && state.url === '/CVDST/promote') {
            return this.router.navigate(['/GYXJ6/CVDST/promote']);
        } else {
            return this.checkAuthentication(route, state);
        }
    }

    private async checkAuthentication(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        const isLoggedIn = this.userService.getAuthToken();

        const hasUserData =
            this.authService.getStorageValue('user_id') &&
            this.authService.getStorageValue('user_hash');

        if (isLoggedIn && hasUserData) {

            this.authService.checkUserStatus(isLoggedIn).then(isActive => {
                if (isActive) {
                    return true;
                }
                this.clearSession();

                const returnUrl = state.url;
                const queryParams: any = {};
                if (returnUrl.length > 1) {
                    queryParams.returnUrl = returnUrl;
                }
                this.router.navigate([this.loginURL], { queryParams });
                return false;
            }).catch(() => {
                this.clearSession();

                const returnUrl = state.url;
                const queryParams: any = {};
                if (returnUrl.length > 1) {
                    queryParams.returnUrl = returnUrl;
                }
                this.router.navigate([this.loginURL], { queryParams });
                return false;
            });
            return true

        } else {
            this.clearSession();

            const returnUrl = state.url;
            const queryParams: any = {};
            if (returnUrl.length > 1) {
                queryParams.returnUrl = returnUrl;
            }
            this.router.navigate([this.loginURL], { queryParams });
            return false;
        }

    }

    private clearSession() {
        const keys = [
            'user_id',
            'user_hash',
            'customer_id',
            'user_customer_id',
            'access_token',
            'sa_access_token',
        ];

        keys.forEach(key => {
            this.Cookies.set(
                key,
                '',
                new Date('Thu, 01 Jan 1970 00:00:01 GMT'),
                '/',
                environment.cookie_domain,
                true,
                environment.cookie_same_site as any
            );
            localStorage.removeItem(key);
        });
    }
}
